import { createActions } from 'redux-actions';
import { InsuranceTemplate } from '@models/InsuranceTemplate';

export type State = {
  templates: InsuranceTemplate[];
};

export type StateUpdatePayload = Partial<State>;

export const {
  insuranceTemplatesFetch,
  stateUpdate,
} = createActions(
  'INSURANCE_TEMPLATES_FETCH',
  'STATE_UPDATE',
  {
    prefix: 'FEATURE_INSURANCE_TEMPLATE',
  },
);
